import { useTranslation } from 'react-i18next';
import { useRootSelector } from '../../../../../store/hooks';
import { selectSiteHeader } from '../../../../../store/features/siteHeader';

import { MetaTags } from '../../../../hub/shared/MetaTags';
import Layout from '../../../shared/layouts/Layout';
import PageLayout from '../../../shared/layouts/PageLayout';
import PaymentProvider from '../../../shared/PaymentProvider';
import PaymentJourneyMessage from '../../../shared/components/PaymentJourneyMessage';
import BookingButton from '../../../shared/components/BookingButton';

export default function OrderExpired() {
  const { t } = useTranslation();
  const siteHeader = useRootSelector(selectSiteHeader);
  const title = siteHeader?.meta?.title || siteHeader?.data?.title || '';
  const pageTitle = title
    ? `${t('site.pricing.payment-expired')} | ${title}`
    : t('site.pricing.payment-expired');

  return (
    <PaymentProvider>
      <Layout disableUpperFooter>
        <MetaTags title={pageTitle} />
        <PageLayout variant="full">
          <PaymentJourneyMessage
            title={t('site.pricing.payment-expired')}
            description={
              <>
                <p>{t('site.pricing.payment-expired.text-1')}</p>
                <p>{t('site.pricing.payment-expired.text-2')}</p>
              </>
            }
            button={<BookingButton size="small" />}
          />
        </PageLayout>
      </Layout>
    </PaymentProvider>
  );
}
